import React from "react"

const SearchIcon = ({
  color,
  w = "24",
  h = "24",
}: {
  color?: string
  w?: string
  h?: string
}) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1586 18.3L22.5 22.5M21.1 11.3C21.1 16.7124 16.7124 21.1 11.3 21.1C5.88761 21.1 1.5 16.7124 1.5 11.3C1.5 5.88761 5.88761 1.5 11.3 1.5C16.7124 1.5 21.1 5.88761 21.1 11.3Z"
        stroke={color || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SearchIcon
